/* eslint no-console: "off" */
export const Logger = (debugMode = false) => {
  const wrapMethod = (logger, propertyName) => {
    logger[propertyName] = (...args) => {
      if (debugMode && console && typeof console[propertyName] === 'function') {
        return console[propertyName](...args);
      }
    };

    return logger;
  };

  return ['error', 'info', 'log', 'warn'].reduce(wrapMethod, {});
};

// Wrapp console methods with debug flag check
export default Logger(!!__DEV__);
